import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { ModalService } from '@avla/ui-design';
import { PhoneListCountry, SelectInterface, vfRut } from '@avla/ui-design/commons';
import { AuthService } from '@services';
import { CreateAccountRequestSI } from '@views/interfaces';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnInit {
  public static modalCreateAccount: string = 'modal-create-account';
  public createAccountForm: FormGroup;
  public response: string = 'onInit';
  public codes: PhoneListCountry[] = [
    {
      code: '+56',
      icon: {
        icon: 'assets/svg/chile-flag.svg',
        type: 'svg',
      },
      country: 'CH',
    },
    {
      code: '+54',
      icon: {
        icon: 'assets/svg/argentina-flag.svg',
        type: 'svg',
      },
      country: 'AR',
    },
    {
      code: '+55',
      icon: {
        icon: 'assets/svg/brazil-flag.svg',
        type: 'svg',
      },
      country: 'BR',
    },
  ];
  public comunasChange: SelectInterface[] = [];
  public fullName: string = '';
  public hiddenV2: boolean = true;
  public token: string | undefined;
  @ViewChild('recaptcha') recaptchaModel!: NgModel;
  public height: number = window.innerHeight;
  @HostListener('window:resize')
  onResize() {
    this.height = window.innerHeight;
  }

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private serviceCaptcha: ReCaptchaV3Service,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.createAccountForm = this.formBuilder.group({
      rut: ['', [Validators.required, vfRut()]],
      name: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'
          ),
        ],
      ],
      rutCompany: ['', [Validators.required, vfRut()]],
      company: ['', [Validators.required]],
      phone: ['', [Validators.minLength(12), Validators.maxLength(14)]],
    });
  }

  get getModalName() {
    return CreateAccountComponent.modalCreateAccount;
  }

  get createAccountIsDisabled(): boolean {
    if (this.recaptchaModel) {
      return this.createAccountForm.invalid || this.recaptchaModel.invalid;
    } else {
      return this.createAccountForm.invalid;
    }
  }

  public async createAccount() {
    if (!this.createAccountIsDisabled) {
      let token = null;
      if (this.hiddenV2) {
        try {
          token = await firstValueFrom(
            this.serviceCaptcha.execute('createAccount')
          );
        } catch {
          this.hiddenV2 = false;
          token = this.token;
          return;
        }
      } else {
        token = this.token;
      }
      try {
        const body: CreateAccountRequestSI = this.createAccountForm.value;
        await this.authService.createAccount(body, token);
        this.response = 'success';
        this.hiddenV2 = true;
      } catch (error: any) {
        if (
          error?.status === 401 ||
          error.error?.errorCode === 'INVALID_CAPTCHA'
        ) {
          this.hiddenV2 = false;
        } else {
          this.response = 'fail';
        }
      }
    }
  }

  public reInit() {
    this.createAccountForm.reset();
    this.response = 'onInit';
  }

  public closeModal() {
    this.modalService.close(CreateAccountComponent.modalCreateAccount);
    this.reInit();
  }
}
